import { deleteProjects } from '@/admin/api/common';
import { ProjectDeletionMode } from '@bimdata/definitions/const';
import { AdminedProject } from '@/admin/types/admined-project.dto';
import handleError from '@/actions/common/handle-error.action';
import reportError from '@/actions/common/report-error.action';

export default async function (list: AdminedProject[], mode: ProjectDeletionMode): Promise<Set<number>> {
  try {
    const ids = new Set<number>(list.map(({ id }) => id));
    const result = await deleteProjects(Array.from(ids), mode);
    if (result) {
      for (const [ pid, errMessage ] of Object.entries(result)) {
        ids.delete(Number(pid));
        reportError(new Error(errMessage));
      }
    }
    return ids;
  } catch (error) {
    handleError(error);
  }
  return new Set();
}